import type { Email } from './emails';

export interface ScriptedEmail {
  readonly fictionalMinutes: number;
  readonly email: Email;
}

export const SCRIPTED_EMAILS: readonly ScriptedEmail[] = [
  {
    fictionalMinutes: 750,
    email: {
      id: 'scripted-dispute-acme-4412',
      from: 'accounts@acmecorp.com',
      subject: 'Double-charged on PO 4412',
      body: "hey — we were double-charged on PO 4412. our records show $1,850 paid already in March. can you credit and resend?",
      receivedAt: '12:30 PM',
      category: 'dispute-followup',
      read: false,
      disputeHook: { customer: 'Acme Corp', invoiceId: 'INV-4412', amountSuggested: 1850 },
    },
  },
];
